import { memo } from 'react';
import { cn, List, PopoverInfo } from '@divlab/divanui';
import { IconAlert } from '@divlab/divanui/icons';

import Img from '@UI/Img';
import styles from './Hardness.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface HardnessProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  icon: string;
  name: string;
  value: string;
  description: string[];
}

const Hardness: FC<HardnessProps> = (props) => {
  const { className, icon, name, value, description, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.hardness, className)}>
      <div className={styles.name}>{name}</div>
      <div className={styles.value}>
        {icon && <Img className={styles.icon} src={icon} />}
        <span className={styles.text}>{value}</span>

        {description?.length > 0 && (
          <PopoverInfo slotTrigger={<IconAlert />} className={styles.popoverInfo}>
            <List
              className={styles.popover}
              items={description}
              renderChild={(item: string) => <div>{item}</div>}
            />
          </PopoverInfo>
        )}
      </div>
    </div>
  );
};

export default memo(Hardness);
